<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in links">
        <div
          v-if="link.url === null"
          :key="key"
          class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded"
          v-html="link.label"
        />
        <button
          v-else
          :key="`link-${key}`"
          class="mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:bg-white border focus:border-indigo-500 rounded"
          :class="{ 'bg-white': link.active }"
          @click="navigate(link.url)"
          v-html="link.label"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array,
    queryParams: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    navigate(url) {
      // Extraer solo el número de página de la URL generada por Laravel
      const page = new URL(url, window.location.origin).searchParams.get('page')
      this.$inertia.get(
        window.location.pathname,
        { ...this.queryParams, ...(page ? { page } : {}) },
        { preserveState: true, preserveScroll: true },
      )
    },
  },
}
</script>
